// import '../home.css';
import Footer from './Footer';


 const Home = () => {
    let image = require("../assets/help_outline.svg")

    const switchPage = (link: any) => {
        localStorage.setItem("prevUrl", window.location.pathname)
        window.location.href = link;
      }

    const loadPractice = (link) => {
        localStorage.setItem("prevUrl", 'practice')
        window.location.href = link;

    }

    const loadSedecordle = () => {
        window.location.href = '/sedecordle';
    }

    const loadSedecorder = () => {
        window.location.href = '/sedec-order';
    }

    return (
<>
<div  className='font-semibold bg-custom dark:bg-custom' style={{maxWidth: '550px', margin: 'auto', height: '100%', display: 'flex'}}>
        <div id="title" width="100%" style={{margin:'auto', flex:'1'}}>
        <center>

            <div style={{width: "67%"}}>
                <table style={{width: '100%'}}>
                    <tr>
						
                        <td className="box button bg-quad bg11" style={{width: '6.4%'}}>S</td>
                        <td className="box button bg-quad bg11" style={{width: '6.4%'}}>E</td>
                        <td className="box button bg-quad bg11" style={{width: '6.4%'}}>D</td>
                        <td className="box button bg-quad bg11" style={{width: '6.4%'}}>E</td>
                        <td className="box button bg-quad bg55" style={{width: '6.4%'}}>C</td>
                        <td className="box button bg-quad bg33" style={{width: '6.4%'}}>O</td>
                        <td className="box button bg-quad bg22" style={{width: '6.4%'}}>R</td>
                        <td className="box button bg-quad bg66" style={{width: '6.4%'}}>D</td>
                        <td className="box button bg-quad bg55" style={{width: '6.4%'}}>L</td>
                        <td className="box button bg-quad bg44" style={{width: '6.4%'}}>E</td>
                    </tr>
                </table>
            </div>

             <div id="tutorial1" style={{padding: '5px', cursor: 'pointer'}}>
                <div onClick={() => switchPage("about")}>
                    <img className="rounded-full bg-black dark:bg-black" src={image.default} width="32" height="32"/>
                </div>
            </div>

            <div onClick={() => loadSedecordle()} className="box bg1" style={{width: '70%', border: 'double', cursor: 'pointer'}} id="daily">
                <table style={{width: '100%'}}>
                    <tr>
                        <td style={{width: '50%', textAlign: 'right'}}>daily</td>
                        <td style={{width: '50%', color: 'black'}}>sedecordle</td>
                    </tr>
                </table>
            </div>
            <div style={{height: '8px'}}>&nbsp;</div>
            <div className="bg3" style={{fontSize: '80%'}}>
                <table style={{width: '100%', color: 'black'}}>
                    <tr>
                        <td style={{width: '50%', textAlign: 'right'}}>a new sedecordle</td>
                        <td style={{width: '50%'}}>each day</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td id="next_daily">every day</td>
                    </tr>
                </table>
            </div>
            <div style={{marginTop: '8px'}}></div>
  
          <div onClick={() => loadPractice('/sedecordle/practice')} className="box bg5" style={{width: '70%', border: 'double', cursor: 'pointer'}} id="free">
                <table style={{width: '100%'}}>
                    <tr>
                        <td style={{width: '50%', textAlign: 'right', color: 'black'}}>free</td>
                        <td style={{width: '50%'}}>sedecordle</td>
                    </tr>
                </table>
            </div>
            <div style={{height: '8px'}}>&nbsp;</div>
            <div className="bg4" style={{fontSize: '80%'}}>
                <table style={{width: '100%', color: 'black'}}>
                    <tr>
                        <td style={{width: '50%', textAlign: 'right'}}>play as much</td>
                        <td style={{width: '50%'}}>as you want</td>
                    </tr>
                    <tr>
                        <td style={{textAlign: 'right'}}>every sedecordle</td>
                        <td>is a surprise</td>
                    </tr>
                </table>
            </div>
            <div className="button">&nbsp;</div>
            <div onClick={() => loadSedecorder()} className="box bg1" style={{width: '70%', border: 'double', cursor: 'pointer'}} id="daily">
                <table style={{width: '100%'}}>
                    <tr>
                        <td style={{width: '50%', textAlign: 'right'}}>daily</td>
                        <td style={{width: '50%', color: 'black'}}>sedec-order</td>
                    </tr>
                </table>
            </div>
            <div style={{height: '8px'}}>&nbsp;</div>
            <div className="bg3" style={{fontSize: '80%'}}>
                <table style={{width: '100%', color: 'black'}}>
                    <tr>
                        <td style={{width: '50%', textAlign: 'right'}}>a new sedec-order</td>
                        <td style={{width: '50%'}}>each day</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td id="next_daily">every day</td>
                    </tr>
                </table>
            </div>
            <div style={{marginTop: '8px'}}></div>
  
          <div onClick={() => loadPractice('/sedec-order/practice')} className="box bg5" style={{width: '70%', border: 'double', cursor: 'pointer'}} id="free">
                <table style={{width: '100%'}}>
                    <tr>
                        <td style={{width: '50%', textAlign: 'right', color: 'black'}}>free</td>
                        <td style={{width: '50%'}}>sedec-order</td>
                    </tr>
                </table>
            </div>
            <div style={{height: '8px'}}>&nbsp;</div>
            <div className="bg4" style={{fontSize: '80%'}}>
                <table style={{width: '100%', color: 'black'}}>
                    <tr>
                        <td style={{width: '50%', textAlign: 'right'}}>play as much</td>
                        <td style={{width: '50%'}}>as you want</td>
                    </tr>
                    <tr>
                        <td style={{textAlign: 'right'}}>every sedec-order</td>
                        <td>is a surprise</td>
                    </tr>
                </table>
            </div>

        </center>
        <div>
    <Footer/>
        </div>
    </div>
    </div>
    </>

    )
}

export default Home;